module.exports = __webpack_public_path__ + "img/single.cddd41c5.png";